// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3nE66","content":"GlobalSearch_content__3XG4z"};